<template>
    <div class="pd15">
        <a-row class="">
            <div class="flex mt15 mb15" style="justify-content: space-between;">
                <div class="flex items-center">
                    <img class="ml15 mr10" src="../../../public/images/guigeguanli.png" style="width:25px;height:25px" />
                    <div class="ml0 fs14" style="color:grey">调运统计表</div>
                </div>
            </div>
        </a-row>
        <div class="bg-white pd20">
            <a-tabs default-active-key="1" >
                <a-tab-pane key="1" tab="调运明细">
                    <a-row class="flex">
                        <div class="flex" >
                            <div class="flex items-center">
                                <a-input size="small" allowClear class="mb10 ml15" v-model="searchInput1" placeholder="请输入关键字" style="width: 300px" enter-button @change="allowClear(1)" @search="onSearch1" @pressEnter="onSearch1" />
                            </div>
                            <div v-if="selectDate == 0" class="flex ml10">
                                <a-date-picker
                                    size="small"
                                    v-model="begin_date"
                                    value-format="YYYY-MM-DD"
                                    :disabled-date="disabledStartDate"
                                    show-time
                                    format="YYYY-MM-DD"
                                    placeholder="开始日期"
                                    @openChange="handleStartOpenChange"
                                    @change="onBeginChange"
                                    class="mr10"
                                />
                                <a-date-picker
                                    size="small"
                                    v-model="end_date"
                                    value-format="YYYY-MM-DD"
                                    :disabled-date="disabledEnd_date"
                                    show-time
                                    format="YYYY-MM-DD"
                                    placeholder="结束日期"
                                />
                            </div>
                            <a-button size="small" class="ml10" type="primary" icon="search" @click="onSearch1">
                                查询
                            </a-button>
                        </div>
                        <!-- <div  style="position: absolute;right:0;">
                            <a-button class="flex items-center" @click="goExportCsv(1)">
                                <img src="images/wenjiandaochu.png" style="width:25px;height: 25px;" />
                                <div class="fs14">导出</div>
                            </a-button>
                        </div> -->
                    </a-row>
                    
                    <a-row :gutter="24" type="flex" align="stretch">
                        <!-- Table -->
                        <a-col :span="24" :lg="30" class="">
                            <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
                                <a-table :data-source="data1" :columns="columns" class="pd15 w100"  :pagination="false" size="small" bordered>
                                
                                </a-table>
                                <a-pagination 
                                    class="flex items-center mb10"
                                    style="justify-content: flex-end"
                                    show-quick-jumper  
                                    v-model="page1.page" 
                                    :total="page1.total" 
                                    :page-size="30"
                                    @change="getTransportData" 
                                />
                            </a-card>
                        </a-col>
                    </a-row>
                </a-tab-pane>
                <a-tab-pane key="2" tab="调运统计">
                    <a-row class="flex">
                        <a-select size="small" class="pl15" default-value="date" style="width: 120px" @change="changeTime">
                            <a-select-option value="date">
                                按日查询
                            </a-select-option>
                            <a-select-option value="month">
                                按月查询
                            </a-select-option>
                        </a-select>
                        <div class="flex items-center">
                            <a-input size="small" allowClear class="mb10 ml10 mr10" v-model="searchInput2" placeholder="请输入关键字" style="width: 300px" enter-button @change="allowClear(2)" @search="onSearch2" @pressEnter="onSearch2" />
                        </div>
                        <div v-if="selectDate == 0" class="flex">
                            <a-date-picker
                                size="small"
                                v-model="begin_date"
                                value-format="YYYY-MM-DD"
                                :disabled-date="disabledStartDate"
                                show-time
                                format="YYYY-MM-DD"
                                placeholder="开始日期"
                                @openChange="handleStartOpenChange"
                                @change="onBeginChange"
                                class="mr10"
                            />
                            <a-date-picker
                                size="small"
                                v-model="end_date"
                                value-format="YYYY-MM-DD"
                                :disabled-date="disabledEnd_date"
                                show-time
                                format="YYYY-MM-DD"
                                placeholder="结束日期"
                                
                            />
                        </div>
                        <a-month-picker size="small" v-else placeholder="选择月份" valueFormat="chooseMonth" @change="onMonthChange" />
                        <a-button size="small" class="ml10" type="primary" icon="search" @click="onSearch2">
                            查询
                        </a-button>
                        <!-- <div style="position: absolute;right:0;">
                            <a-button class="flex items-center" @click="goExportCsv(2)">
                                <img src="images/wenjiandaochu.png" style="width:25px;height: 25px;" />
                                <div class="fs14">导出</div>
                            </a-button>
                        </div> -->
                    </a-row>
                    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
                        <a-table :data-source="data2" :columns="columns" class="pd15 w100" size="small"  :pagination="false" bordered>
                            <span slot="operation" slot-scope="text, record">
                            </span>
                        </a-table>
                        <a-pagination 
                            class="flex items-center mb10"
                            style="justify-content: flex-end"
                            show-quick-jumper  
                            v-model="page2.page" 
                            :total="page2.total" 
                            :page-size="30"
                            @change="getTransportSummary" 
                        />
                    </a-card>
                </a-tab-pane>
            </a-tabs>
        </div>
        
    </div>
</template>
<script>
    export default {
        components: {
    
        },
        data() {
            return {
                data1:[],
                data2:[],
                selectID:1,
                selectDate:0,   //0 按日期 1 按月份
                searchInput1: "",
                searchInput2: "",
                begin_date:"",
                end_date:"",
                chooseMonth:"",
                endOpen:false,
                columns: [
                    {
                        title: '调出项目名称',
                        dataIndex: 'out_project_name',
                        key: 'name',
                        width: '12%',
                        ellipsis: true,
                    },
                    {
                        title: '物资名称',
                        dataIndex: 'material_name',
                        key: 'area',
                        width: '12%',
                        ellipsis: true,
                    },
                    {
                        title: '品牌',
                        dataIndex: 'brand',
                        key: 'brand',
                        ellipsis: true,
                    },
                    {
                        title: '规格',
                        dataIndex: 'size',
                        key: 'size',
                        ellipsis: true,
                    },
                    {
                        title: '单位',
                        dataIndex: 'unit',
                        key: 'unit',
                    },
                    {
                        title: '数量',
                        dataIndex: 'count',
                        key: 'count',
                        // scopedSlots: { customRender: 'operation' },
                    },
                    {
                        title: '调入项目',
                        dataIndex: 'in_project_name',
                        key: 'in_project_name',
                        ellipsis: true,
                    },
                    {
                        title: '时间',
                        dataIndex: 'create_time',
                        key: 'create_time',
                        width: '15%',

                        // scopedSlots: { customRender: 'operation' },
                    },
                ],
                page1:{
                    page:1,
                    total:0
                },
                page2:{
                    page:1,
                    total:0
                },
                search:"",
            }
        },
        created(){
            this.getTransportData()
            this.getTransportSummary()
        },
        methods:{
            goBack(){
                window.history.go(-1);
            },
            async getTransportData(){
                let rs = await this.$api.getTransportData(this.begin_date, this.end_date, this.searchInput1, this.page1.page - 1, 30)
                if(rs.err == 0){
                    this.page1.total = rs.count
                    this.data1 = rs.data
                }
            },
            async getTransportSummary(){
                let rs = await this.$api.getTransportSummary(this.selectDate, this.begin_date, this.end_date, this.chooseMonth, this.searchInput2, this.page2.page - 1, 30)
                if(rs.err == 0){
                    this.page2.total = rs.count
                    this.data2 = rs.data
                }
            },
            async onSearch1(){
                // if((this.searchInput1 == "")&&(this.begin_date.length ==0)&&(this.end_date.length ==0)){
                //     this.$notification['warning']({
                //         message: '查询条件为空',
                //         description:
                //         '请输入关键字进行查询',
                //         style: {
                //             width: '600px',
                //             marginLeft: `${335 - 600}px`,
                //         },
                //     });
                //     return;
                // } 
                this.page1.page = 1
                this.getTransportData()

                
            },
            async onSearch2(){
                // if((this.searchInput2 == "") && (this.begin_date == "") && (this.end_date == "")&&(this.chooseMonth == "")){
                //     this.$notification['warning']({
                //         message: '查询条件为空',
                //         description:
                //         '请输入关键字或选择日期进行查询',
                //         style: {
                //             width: '600px',
                //             marginLeft: `${335 - 600}px`,
                //         },
                //     });
                //     return;
                // } 
                this.page2.page = 1
                this.getTransportSummary()
            },
            disabledStartDate(startValue) {
                const endValue = this.endValue;
                if (!startValue || !endValue) {
                    return false;
                }
                return startValue.valueOf() > endValue.valueOf();
            },
            disabledEnd_date(endValue) {
                const startValue = this.startValue;
                if (!endValue || !startValue) {
                    return false;
                }
                return startValue.valueOf() >= endValue.valueOf();
            },
            handleStartOpenChange(open) {
                if (!open) {
                    this.endOpen = true;
                }
            },
            handleEndOpenChange(open) {
                this.endOpen = open;
            },
            onBeginChange(date, dateString){
                this.begin_date = dateString
            },
            onEndChange(date, dateString){
                this.end_date = dateString
            },
            onMonthChange(date, dateString){
                this.chooseMonth = dateString
            },
            changeTime(){
                this.selectDate = (this.selectDate == 1)? 0 : 1
                this.getTransportSummary()
            },
            // async goExportCsv(id){
            //     let rs = await this.$api.goExportCsv(this.searchInput2, this.begin_date, this.end_date, this.chooseMonth, this.selectDate, id)  
            // }
            allowClear(key){
                if(key == 1){
                    if(this.searchInput1.length == 0){
                        this.page1.page = 1;
                        this.getTransportData()
                    }
                }else if(key == 2){
                    if(this.searchInput2.length == 0){
                        this.page2.page = 1;
                        this.getTransportSummary()
                    }
                }
               
            }
        }

    }

</script>

<style scoped>
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
  